import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
/**
 * Label Atom
 */
export class LabelComponent {
  private _isError = false;
  private _isBig = false;
  private _isGray = false;

  /**
   * Decides if this label is an error message
   * @return {boolean}
   */
  @Input()
  get isError(): boolean {
    return this._isError;
  }

  /**
   * Sets this label as an error message simply by using an html attribute
   * @param {any} value
   */
  set isError(value: any) {
    this._isError = coerceBooleanProperty(value);
  }

  /**
   * Decides if this label is a big one
   * @return {boolean}
   */
  @Input()
  get isBig(): boolean {
    return this._isBig;
  }

  /**
   * Sets this label as a big one by using an html attribute
   * @param {any} value
   */
  set isBig(value: any) {
    this._isBig = coerceBooleanProperty(value);
  }

  /**
   * Decides if this label is gray
   * @return {boolean}
   */
  @Input()
  get isGray(): boolean {
    return this._isGray;
  }

  /**
   * Sets this label as a big one by using an html attribute
   * @param {any} value
   */
  set isGray(value: any) {
    this._isGray = coerceBooleanProperty(value);
  }
}
